/*
 * landing-atc-handler.js — block-scope AJAX submit + cart UI trigger
 *
 * Dawn product-form.js'in sadeleştirilmiş, custom-element-bağımsız hali.
 * <product-form> custom element kullanmaz — constructor crash riski yok.
 *
 * Davranış (settings.cart_type'a göre):
 *   - 'page'         → AJAX add + window.location = '/checkout' (direkt ödeme)
 *   - 'drawer'       → AJAX add + manuel section inject + drawer.open()
 *                      (Dawn cart.renderContents() bu temada drawer'ın ürün listesini
 *                      doğru inject etmiyor; landing-cart-drawer.js upsell extension'ının
 *                      ZATEN test edilmiş manuel parse + innerHTML pattern'i kullanılır)
 *   - 'notification' → AJAX add + cart-notification.renderContents() (toast)
 *                      Notification için section list FARKLI:
 *                      cart-notification-product / cart-notification-button / cart-icon-bubble
 *
 * Hata durumunda fallback: PUB_SUB_EVENTS.cartError publish + /cart redirect.
 *
 * @version 1.3.0 (2026-07-10)
 *   v1.3.0: Gift → cart. Seçili bundle tier'ında data-gift-items varsa ana ürünle birlikte
 *           çoklu-item JSON /cart/add ile hediye varyantlarını da ekler (_gift:'true' property).
 *           Hediye yoksa mevcut FormData yolu AYNEN korunur (regresyon yok). $0'lık merchant'ın
 *           Buy X Get Y otomatik indiriminden gelir — tema fiyat belirlemez.
 *   v1.2.1: Production polish — info-level console.log satırları kaldırıldı (script load,
 *           init, bind, submit triggered, cart_type). console.warn (cart error/missing form/
 *           notification fallback) + console.error (submit failed) korundu — gerçek hatalar.
 *   v1.2.0: cartType kilidi — fallback 'page' → 'drawer' + 'notification' otomatik 'drawer'a
 *           çevriliyor. Setting yanlış kalsa bile drawer her zaman tetiklenir.
 *           Mehmet temasında notification/page modları kullanılmıyor, dead-code yönlendirildi.
 *   v1.1.1: Bind logic JS property'ye taşındı (DOM attribute cache kalıntısı sorununa karşı)
 *           + console.log debug satırları eklendi.
 *   v1.1.0: Mode-spesifik section list + manuel drawer render (Mehmet extension pattern) +
 *           page mode artık /checkout'a redirect ediyor (eski /cart yerine).
 *   v1.0.0: İlk sürüm — cart.renderContents() native API'ye güvenildi, drawer kırıldı.
 */
(function () {
  'use strict';

  function init() {
    var blocks = document.querySelectorAll('.landing-hero-product__atc-block');
    blocks.forEach(function (block, i) {
      var form = block.querySelector('form');
      if (!form) {
        console.warn('[landing-atc] block #' + i + ' has no <form>', block);
        return;
      }
      if (form.__landingAtcBound) return;
      form.__landingAtcBound = true;
      form.addEventListener('submit', handleSubmit);
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var block = form.closest('.landing-hero-product__atc-block');
    var cartType = (block && block.dataset.cartType) || 'drawer';
    if (cartType === 'notification') cartType = 'drawer';

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-busy') === 'true') return;
    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('loading');
    }

    try {
      // Mode-spesifik section list
      var sections;
      if (cartType === 'notification') {
        sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      } else if (cartType === 'drawer') {
        sections = ['cart-drawer', 'cart-icon-bubble'];
      } else {
        sections = ['cart-icon-bubble']; // page mode: sadece bubble update
      }

      var formData = new FormData(form);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      // ─── Gift → cart (v1.3.0) ───
      // Seçili bundle tier'ında hediye varyantları varsa (data-gift-items="id:qty,id:qty"),
      // ana ürünle birlikte tek atomik /cart/add çağrısında sepete ekle. Hediye satırları
      // _gift:'true' line-item property'siyle işaretlenir (görünüm/silme JS'i için; $0'lık
      // merchant'ın Buy X Get Y indiriminden gelir — tema fiyat belirlemez).
      // Bundle radio ATC formunun DIŞINDA (ayrı section) olduğu için document scope'tan okunur.
      var giftItems = [];
      var checkedTier = document.querySelector('.landing-hero-product__tier-radio:checked');
      if (checkedTier && checkedTier.dataset.giftItems) {
        checkedTier.dataset.giftItems.split(',').forEach(function (pair) {
          var parts = pair.split(':');
          var vid = parseInt((parts[0] || '').trim(), 10);
          var gqty = parseInt((parts[1] || '1').trim(), 10) || 1;
          if (vid) giftItems.push({ id: vid, quantity: gqty, properties: { _gift: 'true' } });
        });
      }

      // ─── Per-unit variant picker (F7-R2/T1) ───
      // Aktif kademede "her ünite için varyant seç" açıksa (data-unit-picks
      // görünür), her <select> için ayrı bir sepet item'ı gönderilir — mainItem
      // YERİNE. Kapsayıcı yoksa/hidden'sa bu blok hiç tetiklenmez, bugünkü
      // davranış (mainItem, tek quantity) birebir korunur.
      var unitItems = [];
      var picksEl = document.querySelector('.landing-hero-product__unit-picks:not([hidden])');
      if (picksEl) {
        var unitSelects = picksEl.querySelectorAll('select[data-unit-index]');
        var firstEmpty = null;
        unitSelects.forEach(function (sel) {
          // Önceki bir "eksik seçim" turundan kalmış olabilecek custom validity'yi
          // temizle — yoksa dolu bir select'te bile reportValidity yanlışlıkla
          // eski hatayı gösterebilir.
          if (typeof sel.setCustomValidity === 'function') sel.setCustomValidity('');
          if (!sel.value && !firstEmpty) firstEmpty = sel;
        });
        if (firstEmpty) {
          // Varsayılan varyantla SESSİZCE gönderme — durdur + görünür uyarı.
          // setCustomValidity ile zorlanıyor çünkü <select> markup'ı başka bir
          // dosyada (landing-product-hero.js) üretiliyor ve `required` taşıyıp
          // taşımadığı bu dosyadan garanti edilemez; bu şekilde native tarayıcı
          // balonu her koşulda görünür.
          if (typeof firstEmpty.setCustomValidity === 'function') {
            firstEmpty.setCustomValidity('Lütfen bir varyant seçin.');
          }
          firstEmpty.focus();
          if (typeof firstEmpty.reportValidity === 'function') firstEmpty.reportValidity();
          console.warn('[landing-atc] unit variant seçimi eksik — gönderim durduruldu');
          return;
        }
        var unitMainProps = {};
        var unitSellingPlan = null;
        formData.forEach(function (val, key) {
          var upm = key.match(/^properties\[(.+)\]$/);
          if (upm) unitMainProps[upm[1]] = val;
          if (key === 'selling_plan' && val) unitSellingPlan = val;
        });
        unitSelects.forEach(function (sel) {
          var unitItem = { id: parseInt(sel.value, 10), quantity: 1 };
          if (Object.keys(unitMainProps).length) unitItem.properties = unitMainProps;
          if (unitSellingPlan) unitItem.selling_plan = unitSellingPlan;
          unitItems.push(unitItem);
        });
      }

      var fetchUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      var fetchOpts;
      if (unitItems.length) {
        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: unitItems.concat(giftItems),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        };
      } else if (giftItems.length) {
        // Ana ürünü form'dan JSON item'a çevir (varsa properties[...] + selling_plan taşınır)
        var mainItem = {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1
        };
        var mainProps = {};
        formData.forEach(function (val, key) {
          var pm = key.match(/^properties\[(.+)\]$/);
          if (pm) mainProps[pm[1]] = val;
          if (key === 'selling_plan' && val) mainItem.selling_plan = val;
        });
        if (Object.keys(mainProps).length) mainItem.properties = mainProps;

        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [mainItem].concat(giftItems),
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        };
      } else {
        fetchOpts = {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };
      }

      var response = await fetch(fetchUrl, fetchOpts);
      var data = await response.json();

      if (data.status) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'landing-atc',
            productVariantId: formData.get('id'),
            errors: data.errors || data.description,
            message: data.message
          });
        }
        console.warn('[landing-atc] cart add rejected', data);
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'landing-atc',
          productVariantId: formData.get('id'),
          cartData: data
        });
      }

      // ─── Mode'a göre UI ───
      if (cartType === 'page') {
        // Direkt ödeme sayfası
        window.location = '/checkout';
        return;
      }

      if (cartType === 'notification') {
        var notif = document.querySelector('cart-notification');
        if (notif && typeof notif.renderContents === 'function') {
          notif.cartItemKey = (data.items && data.items[0] && data.items[0].key) || data.key;
          notif.renderContents(data);
        } else {
          console.warn('[landing-atc] cart-notification element DOM\'da yok — /cart\'a fallback');
          window.location = '/cart';
        }
        return;
      }

      // Drawer mode — Mehmet extension pattern (manuel section inject)
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        window.location = '/cart';
        return;
      }

      var parser = new DOMParser();

      if (data.sections && data.sections['cart-drawer']) {
        var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        var newInner = doc.querySelector('#CartDrawer');
        var currentInner = drawer.querySelector('#CartDrawer');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
      }

      if (data.sections && data.sections['cart-icon-bubble']) {
        var iconWrapper = document.querySelector('#cart-icon-bubble');
        if (iconWrapper) {
          var iconDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var newBubble = iconDoc.querySelector('.shopify-section');
          if (newBubble) iconWrapper.innerHTML = newBubble.innerHTML;
        }
      }

      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();

      // landing-cart-drawer.js extension bunu dinler (upsell button re-bind)
      document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));

    } catch (err) {
      console.error('[landing-atc] submit failed', err);
      window.location = cartType === 'page' ? '/checkout' : '/cart';
    } finally {
      if (submitButton) {
        submitButton.removeAttribute('aria-busy');
        submitButton.classList.remove('loading');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
